import { BookWidgetFieldInfoModal } from '../../../models/book-widget-aem.interfaces';

export function getToolTipContent(aemModalContent: BookWidgetFieldInfoModal) {
  if (aemModalContent.title && aemModalContent.description) {
    return aemModalContent;
  }
  return { title: '', description: '' } as BookWidgetFieldInfoModal;
}
